import * as $ from 'jquery';

const settings = {
	element: '.js-map--locations',
	filters: '.js-map-filter'
};

var currentMarker = null;

export const init = () => {
	if (typeof google !== 'undefined') {
		var mapElement = document.querySelector(settings.element);
		if (mapElement) {
			const map = createMap(mapElement);
			const bounds = new google.maps.LatLngBounds();
			const markers = [];
			const attractions = JSON.parse(mapElement.getAttribute('data-attractions'));
			const markersByCategory = {};

			attractions.forEach(function(attraction) {
				const marker = createMarker(map, attraction);

				bounds.extend(marker.position);
				markers.push(marker);

				if (!markersByCategory.hasOwnProperty(attraction.categoryId)) {
					markersByCategory[attraction.categoryId] = [];
				}
				markersByCategory[attraction.categoryId].push(marker);
			});

			if (markers.length > 1) {
				map.fitBounds(bounds, 100); // auto-zoom
				map.panToBounds(bounds); // auto-center
			} else if (markers.length == 1) {
				map.panTo(markers[0].position);
			}

			$(settings.filters).on('change', function () {
				const categoryId = this.getAttribute('data-category-id');
				if (markersByCategory.hasOwnProperty(categoryId)) {
					toggleMarkersVisible(map, markersByCategory[categoryId], this.checked);
				}
			});
		}
	}
}

function createMap(mapElement) {
	var map = new google.maps.Map(mapElement, {
		zoom: 16,
		panControl: false,
		streetViewControl: false,
		overviewMapControl: false,
		mapTypeControl: false,
		scaleControl: false,
		zoomControl: false,
		fullscreenControl: false
	});

	map.element = mapElement;

	// Set up a dummy overlay to get the projection
	map.projectionOverlay = new google.maps.OverlayView();
	map.projectionOverlay.draw = function() {};
	map.projectionOverlay.setMap(map);

	return map;
}

function createMarker(map, attraction) {
	const mapMarker = new google.maps.Marker({
		position: new google.maps.LatLng(attraction.latitude, attraction.longitude),
		map: map,
		icon: {
			path: "M27.648-41.399q0-3.816-2.7-6.516t-6.516-2.7-6.516 2.7-2.7 6.516 2.7 6.516 6.516 2.7 6.516-2.7 2.7-6.516zm9.216 0q0 3.924-1.188 6.444l-13.104 27.864q-.576 1.188-1.71 1.872t-2.43.684-2.43-.684-1.674-1.872l-13.14-27.864q-1.188-2.52-1.188-6.444 0-7.632 5.4-13.032t13.032-5.4 13.032 5.4 5.4 13.032z",
			strokeColor: 'black',
			strokeWeight: 2,
			strokeOpacity: 0.1,
			fillColor: attraction.colour,
			fillOpacity: 1,
			scale: 1,
			anchor: new google.maps.Point(22,0)
		},
		clickable: true,
	});
	mapMarker.attractionId = attraction.id;
	mapMarker.controller = attraction.controller;

	mapMarker.addListener('click', function() {
		setCurrentMarker(map, mapMarker);
		panToLocation(map, mapMarker);
	});

	return mapMarker;
}

function setCurrentMarker(map, mapMarker) {
	if (mapMarker == currentMarker) {
		return;
	}

	if (currentMarker) {
		// Avoid using spread operator as
		// it breaks google map in ie11
		const icon = currentMarker.icon;
		icon.strokeOpacity = 0.1;
		icon.strokeColor = 'black';
		icon.strokeWeight = 2;

		currentMarker.setIcon(icon);

		if (currentMarker.infoWindow) {
			currentMarker.infoWindow.close();
		}
	}

	currentMarker = mapMarker;

	if (currentMarker) {
		// Avoid using spread operator as
		// it breaks google map in ie11
		const icon = currentMarker.icon;
		icon.strokeOpacity = 3;
		icon.strokeColor = 'white';
		icon.strokeWeight = 4;

		currentMarker.setIcon(icon);

		openInfoWindow(map, mapMarker);
	}
}

function panToLocation(map, mapMarker) {
	var proj = map.projectionOverlay.getProjection();
	var current = proj.fromLatLngToContainerPixel(mapMarker.position);

	var $mapElement = $(map.element);
	current.y -= $mapElement[0].getBoundingClientRect().height * 0.35;

	var panTo = proj.fromContainerPixelToLatLng(current);
	map.panTo(panTo);
}

function openInfoWindow(map, mapMarker) {
	var infoWindow = new google.maps.InfoWindow({
		content: '<div class="spinner-border m-5" role="status"><span class="sr-only">Loading...</span></div>',
		pixelOffset: new google.maps.Size(0, 5),
	});
	google.maps.event.addListener(infoWindow, 'closeclick', function() {
		setCurrentMarker(map, null);
	});
	infoWindow.open(map, mapMarker);
	mapMarker.infoWindow = infoWindow;

	$.ajax('/ajax/' + mapMarker.controller + '/view/' + mapMarker.attractionId, {
		success: (result) => {
			infoWindow.setContent(result);
		}
	});
}

function toggleMarkersVisible(map, markers, visible) {
	markers.forEach((marker) => {
		// Avoid using spread operator as
		// it breaks google map in ie11
		const icon = marker.icon;
		icon.scale = visible ? 1 : 0;
		marker.setIcon(icon);

		if (!visible && marker === currentMarker) {
			setCurrentMarker(map, null);
		}
	});
}

init();


